import {QueryParamsEnum} from 'presentation/constants';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {useServicePointsQuery} from 'presentation/pages/private/service-points/queries/useServicePointsQuery';
import {useServicePointsUfsQuery} from 'presentation/pages/private/service-points/queries/useServicePointsUfsQuery';

export function useServicePoints() {
	const {isMobile} = useMediaQueries();
	const {
		SEARCH_PARAMS: {query, ufCode},
		setSearchParams,
	} = useQueryParams();

	const {
		data: servicePoints,
		loadMore,
		isFetchingNextPage,
		isLoading: isServicePointsLoading,
		isError: isServicePointsError,
		refetch: refetchServicePoints,
	} = useServicePointsQuery();
	const {
		data: ufsData,
		isLoading: isUfsLoading,
		isError: isUfsError,
	} = useServicePointsUfsQuery();

	const ufs = ufsData?.ufs ?? [];

	const hasSingleServicePointInUf = servicePoints?.length === 1 && ufs.length === 1 && !query;

	const hideFilters = hasSingleServicePointInUf || isServicePointsError;

	const showEmptyState =
		Boolean(query || ufCode) && servicePoints?.length === 0 && !isServicePointsLoading;

	const hideServicePointsComponent =
		isServicePointsLoading || isServicePointsError || showEmptyState;

	const handleClearFilters = () => {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.UF_CODE);
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				return prev;
			},
			{replace: true},
		);
	};

	return {
		isMobile,
		servicePoints,
		loadMore,
		isFetchingNextPage,
		isServicePointsLoading,
		isServicePointsError,
		isUfsLoading,
		isUfsError,
		ufs,
		hideFilters,
		showEmptyState,
		refetchServicePoints,
		handleClearFilters,
		hideServicePointsComponent,
	};
}
